import { SIQArticleTheme } from "./SIQArticleTheme";
import { SIQFAQListItemTheme } from "./SIQFAQListItemTheme";
export class SIQFAQTheme {
  headerTextColor = "null";
  ListItem = new SIQFAQListItemTheme();
  Article = new SIQArticleTheme();
}
//# sourceMappingURL=SIQFAQTheme.js.map